<button mat-mini-fab class="mat-mini-fab-map-control" (click)="locateMe()" [matTooltip]="'map.control_go_to_position.tooltip' | translate"
  matTooltipPosition="left" matTooltipShowDelay="1000">
  <mat-icon>my_location</mat-icon>
</button>
